import React from "react";
import MasterSuiteWorkspace from "../../components/mastersuite/MasterSuiteWorkspace";

// Full-page Create Master Suite (workflow canvas + editable table).
function MasterSuiteNewPage() {
  return <MasterSuiteWorkspace mode="create" />;
}

export default MasterSuiteNewPage;
